import { render, staticRenderFns } from "./DeliverableDetail.vue?vue&type=template&id=64fd8e4c&scoped=true&"
import script from "./DeliverableDetail.vue?vue&type=script&lang=js&"
export * from "./DeliverableDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeliverableDetail.vue?vue&type=style&index=0&id=64fd8e4c&scoped=true&lang=scss&"
import style1 from "./DeliverableDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fd8e4c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VMenu,VProgressCircular,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64fd8e4c')) {
      api.createRecord('64fd8e4c', component.options)
    } else {
      api.reload('64fd8e4c', component.options)
    }
    module.hot.accept("./DeliverableDetail.vue?vue&type=template&id=64fd8e4c&scoped=true&", function () {
      api.rerender('64fd8e4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/deliverable/DeliverableDetail.vue"
export default component.exports